import type { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import Swal from 'sweetalert2/dist/sweetalert2.js';

const swal = (options: SweetAlertOptions) =>
    Swal.fire(options) as Promise<SweetAlertResult>;
swal.DismissReason = Swal.DismissReason;
swal.close = Swal.close;

export default swal;
